import { backendNode } from "System/system";
import store from "System/reduxStore";

// -------------------------------------------------------
// -------------------------------------------------------
export const listProjects = () => async (dispatch) => {
  dispatch({ type: "SET_PROJECTS", projects: null });
  const data = store.getState();
  const { uid } = data.user;
  const results = await backendNode("project", "list", { uid });
  if (results.data) {
    const { projects } = results.data;
    dispatch({ type: "SET_PROJECTS", projects: projects.sort((a, b) => b.modified - a.modified) });
  }
};
